import { HOUSING, PRIORITIES, QUICK_ASSETS, ROOMS, Chip, Field } from "@/components/onboarding/parts";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { DatePicker } from "@/components/common/DatePicker";

export const StepHousehold = ({ v, set }) => (
  <div className="space-y-6">
    <Field id="ob-name" label="Nom de votre foyer" value={v.name} onChange={(e) => set({ name: e.target.value })} placeholder="Ex. Maison de famille" data-testid="onboarding-household-name-input" />
    <div>
      <div className="mb-2 text-sm font-medium">Type de logement</div>
      <div className="grid grid-cols-2 gap-2">
        {HOUSING.map((h) => <Chip key={h.key} {...h} active={v.housing_type === h.key} onClick={() => set({ housing_type: h.key })} testid={`onboarding-housing-${h.key}`} />)}
      </div>
    </div>
    <div>
      <div className="mb-2 text-sm font-medium">Pays</div>
      <Select value={v.country} onValueChange={(country) => set({ country, currency: country === "CH" ? "CHF" : "EUR" })}>
        <SelectTrigger className="h-11 rounded-xl" data-testid="onboarding-country-select"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="FR">France</SelectItem><SelectItem value="BE">Belgique</SelectItem>
          <SelectItem value="CH">Suisse</SelectItem><SelectItem value="LU">Luxembourg</SelectItem>
        </SelectContent>
      </Select>
    </div>
  </div>
);

export const StepGoals = ({ v, set }) => {
  const toggle = (k) => set({ priorities: v.priorities.includes(k) ? v.priorities.filter((p) => p !== k) : [...v.priorities, k] });
  return (
    <div className="space-y-6">
      <div className="grid gap-2 sm:grid-cols-2">
        {PRIORITIES.map((p) => <Chip key={p.key} {...p} active={v.priorities.includes(p.key)} onClick={() => toggle(p.key)} testid={`onboarding-priority-${p.key}`} />)}
      </div>
      <div className="rounded-2xl border border-dashed border-border p-4">
        <div className="text-sm font-medium">Un premier objectif d'épargne ? <span className="font-normal text-muted-foreground">(facultatif)</span></div>
        <div className="mt-3 grid gap-3 sm:grid-cols-[1fr_9rem]">
          <Field id="ob-goal-name" label="Projet" value={v.goal_name} onChange={(e) => set({ goal_name: e.target.value })} placeholder="Ex. Vacances d'été" data-testid="onboarding-goal-name-input" />
          <Field id="ob-goal-target" label="Montant" type="number" min="1" value={v.goal_target} onChange={(e) => set({ goal_target: e.target.value })} placeholder="1500" data-testid="onboarding-goal-target-input" />
        </div>
      </div>
    </div>
  );
};

export const StepAsset = ({ v, set }) => (
  <div className="space-y-6">
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
      {QUICK_ASSETS.map((a) => (
        <Chip key={a.name} icon={a.icon} tone={a.tone} label={a.name} active={v.asset_name === a.name}
          onClick={() => set({ asset_name: a.name, asset_category: a.category, asset_room: a.room })} testid={`onboarding-asset-${a.category}-${a.room}`} />
      ))}
    </div>
    <div className="grid gap-3 sm:grid-cols-2">
      <Field id="ob-asset-name" label="Équipement" value={v.asset_name} onChange={(e) => set({ asset_name: e.target.value })} placeholder="Ex. Lave-vaisselle" data-testid="onboarding-asset-name-input" />
      <Field id="ob-asset-brand" label="Marque (facultatif)" value={v.asset_brand} onChange={(e) => set({ asset_brand: e.target.value })} data-testid="onboarding-asset-brand-input" />
      <div>
        <div className="mb-1.5 text-sm font-medium">Pièce</div>
        <Select value={v.asset_room} onValueChange={(asset_room) => set({ asset_room })}>
          <SelectTrigger className="h-11 rounded-xl" data-testid="onboarding-asset-room-select"><SelectValue placeholder="Choisir" /></SelectTrigger>
          <SelectContent>{ROOMS.map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div><Label htmlFor="ob-asset-date">Date d'achat (facultatif)</Label><DatePicker id="ob-asset-date" className="mt-1.5 h-11 rounded-xl" value={v.asset_date} onChange={(e) => set({ asset_date: e.target.value })} placeholder="Date d'achat" data-testid="onboarding-asset-date-input" /></div>
      <Field id="ob-asset-price" label="Prix d'achat (facultatif)" type="number" min="0" value={v.asset_price} onChange={(e) => set({ asset_price: e.target.value })} data-testid="onboarding-asset-price-input" />
    </div>
    <p className="text-xs text-muted-foreground">La facture, la garantie et le passeport numérique de cet équipement arriveront avec la Partie 3.</p>
  </div>
);
